import { useMutation } from 'react-query';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { deployProject } from 'src/services/napi/projects/deployProject';
import { UseMutateProjectInterface } from './interfaces/useMutateProject.interface';
import { useNotification } from '../../../providers/notificationsProvider/index';

// eslint-disable-next-line no-unused-vars
const postDeployment = async () => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject?._id) return;

  const response = await deployProject(currentProject._id);
  return response;
};

export const useDeployProject = ({ onError, onSuccess }: UseMutateProjectInterface) => {
  const { notify } = useNotification();

  return useMutation(() => postDeployment(), {
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      notify({ message: 'Project was deployed successfully' });
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
